import { render, staticRenderFns } from "./SeventhPage.vue?vue&type=template&id=7631ff2b&scoped=true"
import script from "./SeventhPage.vue?vue&type=script&lang=js"
export * from "./SeventhPage.vue?vue&type=script&lang=js"
import style0 from "./SeventhPage.vue?vue&type=style&index=0&id=7631ff2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7631ff2b",
  null
  
)

export default component.exports